import { render, staticRenderFns } from "./UnitDetailCard.vue?vue&type=template&id=357a93f6"
import script from "./UnitDetailCard.vue?vue&type=script&lang=js"
export * from "./UnitDetailCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports